import Feature7 from './Feature7'
export default Feature7
